function debounce(fn, wait = 150) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

const videoControls = (v) => {
  const buttons = document.querySelectorAll(".playpause");
  buttons.forEach((button) => {
    const playIcon = button.querySelector(".play");
    const pauseIcon = button.querySelector(".pause");
    button.addEventListener("click", (event) => {
      const myVideo = document.getElementById(
        button.getAttribute("aria-labelledby")
      );
      if (myVideo.paused) {
        myVideo.play();
        playIcon.style.display = "none";
        pauseIcon.style.display = "block";
      } else {
        myVideo.pause();
        playIcon.style.display = "block";
        pauseIcon.style.display = "none";
      }
    });
  });
};

videoControls();

const addToCart = (id, qty, properties = false, callback = false) => {
  let formData = {
    items: [
      {
        id: id,
        quantity: qty,
        properties: {},
      }
    ],
  };

  const cartDrawer = document.querySelector("cart-drawer");

  if (properties) {
    formData.items[0].properties = properties;
  }

  fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      return response.json();
    })
    .then((cart) => {
      if (callback && typeof callback === "function") {
        callback();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

const lazyImages = () => {
  if (
    "loading" in HTMLImageElement.prototype &&
    "IntersectionObserver" in window
  ) {
    var lazyImages = document.querySelectorAll(".media img");

    const imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const image = entry.target;
            let loadedSuccessfully = image.complete && image.naturalWidth !== 0;
            if (loadedSuccessfully) {
              image.parentNode.classList.add("loaded");
            } else {
              setTimeout(function () {
                image.parentNode.classList.add("loaded");
              }, 250);
            }
            imageObserver.unobserve(image);
          }
        });
      },
      {
        threshold: 0.25,
      }
    );

    lazyImages.forEach((img) => imageObserver.observe(img));
  }
};

const lazyIframes = () => {
  if (
    "loading" in HTMLImageElement.prototype &&
    "IntersectionObserver" in window
  ) {
    var lazyIframes = document.querySelectorAll("iframe[data-src]");

    const imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const iframe = entry.target;
            iframe.src = iframe.dataset.src;
            iframe.parentNode.classList.add("loaded");
            imageObserver.unobserve(iframe);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    lazyIframes.forEach((iframe) => imageObserver.observe(iframe));
  }
};

const scrollToLinks = () => {
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      if (event.target.href === "#") return;
      event.preventDefault();

      document.querySelector(event.target.getAttribute("href")).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  lazyImages();
  lazyIframes();
  scrollToLinks();
  klaviyoForms();
});

document.addEventListener("shopify:section:load", () => {
  lazyImages();
  lazyIframes();
  scrollToLinks();
  klaviyoForms();
});

const klaviyoSubscribe = (form, callback) => {
  const email = form.querySelector('input[name="email"]').value;
  const listId = form.querySelector('input[name="g"]').value;
  const successMessage = form.getAttribute("data-success-message");
  const messages = form.querySelector(".messages");
  const subscribeUrl = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";

  if (email === "") {
    messages.textContent = "Please enter a valid email address";
    messages.classList.remove("hidden");
    return false;
  }

  const bodyContent = {
    g: listId,
    email: email,
  };

  fetch(subscribeUrl, {
    body: new URLSearchParams(bodyContent),
    method: "POST",
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        messages.textContent = successMessage;
      } else {
        messages.textContent = response.errors;
      }

      messages.classList.remove("hidden");
      if (callback && typeof callback === "function") {
        callback();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const klaviyoForms = () => {
  const subscribeForms = document.querySelectorAll(".klaviyo-subscribe");

  subscribeForms.forEach((form) => {
    const button = form.querySelector("[type=submit]");

    button.addEventListener("click", function (e) {
      e.preventDefault();
      klaviyoSubscribe(form);
    });
  });
};

window.addEventListener("cartItemAdd", function (data) {
  addToCart(data.detail.id, data.detail.quantity);
});
